import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { useRoot } from 'context/RootContext';
import { ALERT_VARIANTS, LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';

const useShiftTakings = id => {
  const path = `${API_ENDPOINTS.SHIFTS}/takings?id=${id}`;
  const { t } = useTranslation(LOCALIZATION_PAGES.SHIFT);
  const { showNotification } = useRoot();
  const [{ result: shiftTakings, loading, error }, getShiftTakings] = useApi(path, { initialFetch: false });

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('shift_takings_fetch_fail'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  return [{ shiftTakings, loading, error }, getShiftTakings];
};

export default useShiftTakings;
